// removed by extract-text-webpack-plugin
module.exports = {"body":"_1vUi6dH-n6aX9RKbZJfuyR","fullHeight":"_2hal0y7S2mn5xmUvDgm2Re"};


//////////////////
// WEBPACK FOOTER
// ./components/Customers/CustomersHome.module.css
// module id = 2339
// module chunks = 1